"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Ant = __importStar(require("antd"));
var styled_components_1 = __importDefault(require("styled-components"));
var PrismCss_1 = __importDefault(require("../../CustomWidgets/RevCodeArea/PrismCss"));
function RevWebDevEditor(props) {
  var schema = props.schema,
    uiSchema = props.uiSchema,
    formData = props.formData;
  var modalContentRef = react_1.default.useRef();
  var _a = react_1.default.useState('html'),
    selectedLang = _a[0],
    setSelectedLang = _a[1];
  var _b = react_1.default.useState(false),
    openModal = _b[0],
    setOpenModal = _b[1];
  var _c = react_1.default.useState(true),
    highlight = _c[0],
    setHighlight = _c[1];
  if (uiSchema.hidden) {
    return null;
  }
  return react_1.default.createElement("div", null, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, react_1.default.createElement("div", null, (schema === null || schema === void 0 ? void 0 : schema.title) || ''), react_1.default.createElement(Ant.Button, {
    style: {
      marginLeft: 8
    },
    onClick: function onClick() {
      return setOpenModal(true);
    }
  }, "\u7DE8\u8F2F")), react_1.default.createElement(Ant.Modal, {
    visible: openModal,
    width: "80%",
    onCancel: function onCancel() {
      return setOpenModal(false);
    },
    destroyOnClose: true,
    bodyStyle: {
      padding: 0
    },
    style: {
      padding: 0
    },
    footer: null
  }, react_1.default.createElement("div", {
    style: {
      padding: '40px 20px'
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, react_1.default.createElement("input", {
    id: "rev-hl-syntax",
    type: "checkbox",
    checked: highlight,
    onChange: function onChange(e) {
      if (window.confirm('尚未儲存的資料將會丟失, 確定要繼續嗎?')) {
        setHighlight(e.target.checked);
      }
    }
  }), react_1.default.createElement("label", {
    htmlFor: "rev-hl-syntax",
    style: {
      marginLeft: 8
    }
  }, "Syntax highlight")), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, ['html', 'css', 'javascript'].map(function (lang) {
    return react_1.default.createElement(Ant.Button, {
      type: selectedLang === lang ? 'primary' : 'link',
      onClick: function onClick() {
        var _a;
        if (selectedLang !== lang) {
          if ((_a = modalContentRef === null || modalContentRef === void 0 ? void 0 : modalContentRef.current) === null || _a === void 0 ? void 0 : _a.isChanged()) {
            if (!window.confirm('尚未存檔，確定要切換嗎?')) {
              return;
            }
          }
        }
        setSelectedLang(lang);
      }
    }, lang.toUpperCase());
  })), highlight ? react_1.default.createElement(ModalContent, __assign({
    key: selectedLang,
    lang: selectedLang,
    ref: modalContentRef
  }, props, {
    value: formData[selectedLang] || ''
  })) : react_1.default.createElement(TextEditor, __assign({
    key: selectedLang,
    lang: selectedLang,
    ref: modalContentRef
  }, props, {
    value: formData[selectedLang] || ''
  })))));
}
exports.default = RevWebDevEditor;
function ModalContentImpl(props, ref) {
  var lang = props.lang,
    initialValue = props.value;
  var textareaElemRef = react_1.default.useRef(null);
  var highlightElemRef = react_1.default.useRef(null);
  var codeElemRef = react_1.default.useRef(null);
  var _a = react_1.default.useState(initialValue),
    value = _a[0],
    setValue = _a[1];
  ref.current = {
    getValue: function getValue() {
      return value;
    },
    isChanged: function isChanged() {
      return value !== props.value;
    }
  };
  var syncContent = react_1.default.useCallback(function (nextValue) {
    if (!codeElemRef.current || !textareaElemRef.current || !highlightElemRef.current) {
      return;
    }
    var Prism = window.Prism;
    if (!Prism) {
      return;
    }
    setValue(nextValue);
    var html = Prism.highlight(nextValue, Prism.languages[lang], lang);
    codeElemRef.current.innerHTML = html;
  }, [lang]);
  react_1.default.useEffect(function () {
    syncContent(initialValue);
  }, [initialValue, syncContent]);
  var syncScroll = react_1.default.useCallback(function () {
    if (!codeElemRef.current || !textareaElemRef.current || !highlightElemRef.current) {
      return;
    }
    highlightElemRef.current.scrollTop = textareaElemRef.current.scrollTop;
    highlightElemRef.current.scrollLeft = textareaElemRef.current.scrollLeft;
  }, []);
  react_1.default.useEffect(function () {
    syncScroll();
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Wrapper, null, react_1.default.createElement("textarea", {
    id: "wd-editing",
    ref: textareaElemRef,
    spellCheck: false,
    value: value,
    onInput: syncScroll,
    onScroll: syncScroll,
    onChange: function onChange(e) {
      return syncContent(e.target.value);
    }
  }), react_1.default.createElement("pre", {
    id: "wd-highlighting",
    "aria-hidden": true,
    ref: highlightElemRef
  }, react_1.default.createElement("code", {
    className: "language-" + lang,
    ref: codeElemRef
  }))), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, react_1.default.createElement(Ant.Button, {
    disabled: value === props.value,
    onClick: function onClick() {
      var _a;
      props.onChange(__assign(__assign({}, props.formData), (_a = {}, _a[lang] = value, _a)));
    }
  }, "\u4FEE\u6539")));
}
var ModalContent = react_1.default.forwardRef(ModalContentImpl);
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n  height: 500px;\n\n  #wd-editing,\n  #wd-highlighting {\n    /* Both elements need the same text and space styling so they are directly on top of each other */\n    position: absolute;\n    margin: 10px 0;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border: 1px solid #ccc;\n    width: 100%;\n    height: 450px;\n    background-color: white;\n  }\n\n  #wd-editing,\n  #wd-highlighting,\n  #wd-highlighting * {\n    /* Also add text styles to highlighting tokens */\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n  }\n\n  #wd-editing {\n    z-index: 1;\n  }\n\n  #wd-highlighting {\n    z-index: 0;\n  }\n\n  #wd-editing {\n    color: transparent;\n    background: transparent;\n    caret-color: blue; /* Or choose your favorite color */\n  }\n\n  /* Can be scrolled */\n  #wd-editing,\n  #wd-highlighting {\n    overflow: auto;\n    white-space: nowrap; /* Allows textarea to scroll horizontally */\n  }\n"], ["\n  ", "\n\n  position: relative;\n  height: 500px;\n\n  #wd-editing,\n  #wd-highlighting {\n    /* Both elements need the same text and space styling so they are directly on top of each other */\n    position: absolute;\n    margin: 10px 0;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border: 1px solid #ccc;\n    width: 100%;\n    height: 450px;\n    background-color: white;\n  }\n\n  #wd-editing,\n  #wd-highlighting,\n  #wd-highlighting * {\n    /* Also add text styles to highlighting tokens */\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n  }\n\n  #wd-editing {\n    z-index: 1;\n  }\n\n  #wd-highlighting {\n    z-index: 0;\n  }\n\n  #wd-editing {\n    color: transparent;\n    background: transparent;\n    caret-color: blue; /* Or choose your favorite color */\n  }\n\n  /* Can be scrolled */\n  #wd-editing,\n  #wd-highlighting {\n    overflow: auto;\n    white-space: nowrap; /* Allows textarea to scroll horizontally */\n  }\n"])), PrismCss_1.default);
function TextEditorImpl(props, ref) {
  var lang = props.lang,
    initialValue = props.value;
  var textareaElemRef = react_1.default.useRef(null);
  var _a = react_1.default.useState(initialValue),
    value = _a[0],
    setValue = _a[1];
  ref.current = {
    getValue: function getValue() {
      return value;
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    style: {
      height: 500,
      width: '100%',
      padding: '10px 0',
      display: 'flex',
      marginBottom: 20
    }
  }, react_1.default.createElement("textarea", {
    style: {
      border: '1px solid #ccc',
      flex: 1,
      alignSelf: 'stretch',
      padding: 10
    },
    ref: textareaElemRef,
    spellCheck: false,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  })), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, react_1.default.createElement(Ant.Button, {
    disabled: value === props.value,
    onClick: function onClick() {
      var _a;
      props.onChange(__assign(__assign({}, props.formData), (_a = {}, _a[lang] = value, _a)));
    }
  }, "\u4FEE\u6539")));
}
var TextEditor = react_1.default.forwardRef(TextEditorImpl);
var templateObject_1;